import * as React from 'react';
import { Redirect } from 'react-router-dom';

import NavBar from '../../../../components/CustomNav/CustomNav.Component';
import ProgressBar from '../../../../common/progressBar.Component';
import { StyledRow, ContentWrapper, IconWrapper } from '../UserEngagement.styles';
import { Container, Footer } from '../../Common/Common.styles';
import withServices from '../../../../HOCs/withServices';

// temp icons, maybe :-)
import energy from '../../../../assets/images/onboard/energy-icon.svg'
import feelgood from '../../../../assets/images/onboard/feelgood-icon.svg'
import memory from '../../../../assets/images/onboard/memory-icon.svg'
import casual from '../../../../assets/images/onboard/casual-icon.svg'
import foreexams from '../../../../assets/images/onboard/forexams1-icon.svg'
import insane from '../../../../assets/images/onboard/insane-icon.svg'
import less5 from '../../../../assets/images/onboard/less5-icon.svg'
import less30 from '../../../../assets/images/onboard/less30-icon.svg'
import less100 from '../../../../assets/images/onboard/less100-icon.svg'
import less500 from '../../../../assets/images/onboard/less500-icon.svg'
import more500 from '../../../../assets/images/onboard/more500-icon.svg'
import nextterm from '../../../../assets/images/onboard/nextterm-icon.svg'
import nextweek from '../../../../assets/images/onboard/nextweek-icon.svg'
import organized from '../../../../assets/images/onboard/organized-icon.svg'
import performance from '../../../../assets/images/onboard/performance-icon.svg'
import regular from '../../../../assets/images/onboard/regular-icon.svg'
import revision from '../../../../assets/images/onboard/revision-icon.svg'
import schedule from '../../../../assets/images/onboard/schedule-icon.svg'
import serious from '../../../../assets/images/onboard/serious-icon.svg'
import timebomb from '../../../../assets/images/onboard/timebomb-icon.svg'
import { response } from 'src/assets/data/sampleResults';

const icons = {
    "energy": energy,
    "feelgood": feelgood,
    "memory": memory,
    "casual": casual,
    "forexams": foreexams,
    "insane": insane,
    "less5": less5,
    "less30": less30,
    "less100": less100,
    "less500": less500,
    "more500": more500,
    "nextterm": nextterm,
    "nextweek": nextweek,
    "organized": organized,
    "performance": performance,
    "regular": regular,
    "revision": revision,
    "schedule": schedule,
    "serious": serious,
    "timebomb": timebomb
}

interface IProps {
    services?: any;
    history?: any;
    isParent?: boolean;
    isSchool?: boolean;
    isStudent?: boolean;
}

interface IState {
    navigate: boolean;
    destination: string;
    questionsSet: any;
    userType: string;
    currentIdx: number;
    currentQuestionResponses: any;
    payload: any,
    onboardingQuestions: any;
}

class UserEngagement extends React.Component<IProps, IState> {
    private ls = window.localStorage;
    constructor(props) {
        super(props);
        this.state = {
            destination: '',
            navigate: false,
            questionsSet: {} as any,
            userType: '',
            currentIdx: 0,
            currentQuestionResponses: [],
            payload: {} as any,
            onboardingQuestions: []
        }

        this.onLogout = this.onLogout.bind(this);
        this.renderQuestionSet = this.renderQuestionSet.bind(this);
        this.selectAnswer = this.selectAnswer.bind(this);
    }

    public async componentDidMount() {
        const onboardQuestionCompleted = this.ls.getItem('onboardingcompleted');
        if (onboardQuestionCompleted === 'true') {
            let destination = '';
            const userType = this.ls.getItem('usertype');
            if (userType === 'student') {
                destination = '/plexing';
            }
            if(userType === 'parent') {
                destination = '/onboarding/register/parent'
            }
            if(userType === 'school') {
                destination = '/onboarding/school/booking'
            }
            const navigate = true;
            this.setState({ destination, navigate });
        }
        const { isParent, isSchool, isStudent, services: { fixturesAPI } } = this.props;
        if (isStudent) {
            const response = await fixturesAPI.getUserOnboardingQuestions('student');
            this.setState({ questionsSet: response.questionSets });
        }
        if (isSchool) {
            const response = await fixturesAPI.getUserOnboardingQuestions('school');
            this.setState({ questionsSet: response.questionSets });
        }
        if (isParent) {
            const response = await fixturesAPI.getUserOnboardingQuestions('parent');
            this.setState({ questionsSet: response.questionSets });
        }

    }

    public onLogout() {
        this.setState({ navigate: true, destination: '/login' });
    }
    public initializeDailyVals() {
        // initialize & set daily goal vals to 0 in localstorage
        // values required in the next component
        this.ls.setItem('sun', '0');
        this.ls.setItem('mon', '0');
        this.ls.setItem('tue', '0');
        this.ls.setItem('wed', '0');
        this.ls.setItem('thu', '0');
        this.ls.setItem('fri', '0');
        this.ls.setItem('sat', '0');
    }

    public selectAnswer(id, metric, value, question, response) {
        const {currentIdx, questionsSet, onboardingQuestions} = this.state;
        const currentQns = {
            id,
            question,
            response
        }
        const questions = Array.from(onboardingQuestions);
        questions.push(currentQns);
        this.setState({onboardingQuestions: questions});
        console.log("onboardQns" + JSON.stringify(questions, null, 2))

        if(currentIdx >= questionsSet.length - 1){
            // set last metric before routing away
            this.ls.setItem(metric, value);
            // set item showing onboarding questions are completed localStorage only takes strings
            this.ls.setItem('onboardingcompleted', 'true');
            this.ls.setItem('onboardingQuestions', JSON.stringify(questions));
            this.initializeDailyVals();
            this.navigate();
        } else {
            const nextIdx = currentIdx + 1;
            this.ls.setItem(metric, value);
            this.setState({currentIdx: nextIdx});
        }
    }

    public navigate() {
        const { history, isParent, isStudent, isSchool } = this.props;
        isParent ? history.push(`/onboarding/register/parent`): isSchool ? history.push(`/onboarding/school/booking`) : history.push(`/plexing`);
    }

    public renderQuestionSet() {
        const { questionsSet, currentIdx } = this.state;
        console.log('QuestionSet: ' + JSON.stringify(questionsSet, null, 4))
        if(questionsSet.length){
            const currentQuestionSet = questionsSet[currentIdx];
            const currentQuestionResponses = currentQuestionSet.responses;
            const currentQuestion = currentQuestionSet.question;
            const currentMetric = currentQuestionSet.metric;
            const currentId = currentQuestionSet.id

            return (
                <div>
                    <h2>{currentQuestion} </h2>
                    <ContentWrapper>
                        {currentQuestionResponses.map((response) => 
                            <IconWrapper key={response.id} onClick={this.selectAnswer.bind(this, currentId, currentMetric, response.value, currentQuestion, response.text)}>
                                <div className="icon-wrap">
                                    <img src={icons[response.icon]} alt="" />
                                </div>
                                <p className="icon-description">{response.text}</p>
                            </IconWrapper>
                        )
                        }
                    </ContentWrapper>
                </div>
            )
        } else {
            // add a loader
            return <div />
        }
    }

    public render() {
        if (this.state.navigate) {
            return <Redirect to={this.state.destination} />
        }

        return (
            <Container>
                <NavBar logoutParent={this.onLogout} />
                <StyledRow>

                    <div className="progress-wrap">
                        <ProgressBar
                            fraction={this.state.currentIdx + 1}
                            total={this.state.questionsSet.length}
                            showLabel={true}
                        />
                    </div>

                    {this.renderQuestionSet()}
                </StyledRow>
            </Container>
        )
    }
}

export default withServices(UserEngagement);


// WEBPACK FOOTER //
// ./src/pages/Onboard/UserEngagement/UserJourney/UserEngagementPage.Component.tsx